export default {
  "content": "<path d=\"M10.207 14.707L7.414 17.5H16c2.16 0 3.975-1.665 3.975-3.5h2c0 3.165-2.95 5.5-5.975 5.5H7.414l2.793 2.793-1.414 1.414-4.5-4.5a1 1 0 010-1.414l4.5-4.5 1.414 1.414zM4.5 15h-3v-3h3v3zM22.5 12h-3V9h3v3zM19.707 4.793a1 1 0 010 1.414l-4.5 4.5-1.414-1.414L16.586 6.5H8c-2.16 0-3.976 1.665-3.976 3.5h-2c0-3.165 2.951-5.5 5.976-5.5h8.586l-2.793-2.793L15.207.293l4.5 4.5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};